import { initFlowHelpers, addAssociatedIDs } from '../../../../flow/helpers.js';
import '@caresend/utils';
import '@caresend/types';
import '@sentry/vue';
import { toastError } from '../../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../../components/ui/Icon.vue.js';
import '../../../../functions/configuration/icons.js';
import '../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../functions/tracking/index.js';
import 'immutability-helper';
import { getRoute } from '../../../../router/helpers/initRouter.js';
import '../../../../router/routes/dev/model.js';
import '../../../../router/routes/dev/routes.js';
import '../../../../router/routes/dashboard/model.js';
import '../../../../router/routes/pro/model.js';
import '../../../../router/routes/visitsPage/model.js';
import '../../../../router/routes/orderFlow/model.js';
import '../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../router/routes/orderFlow/routes.js';
import '../../../../router/routes/schedulingFlow/model.js';
import '../../../../router/routes/schedulingFlow/routes.js';
import { ChartingFlowRouteName } from '../../../../router/routes/chartingFlow/model.js';
import '../../../../router/routes/chartingFlow/routes.js';
import '../../../../router/routes/portal/portalRoutes.js';
import '../../../../router/routes/portal/model.js';
import '../../../../router/routes/visitsPage/routes.js';
import { getStore } from '../../../helpers/initStore.js';
import { chartingFlowCompletionActions } from './completionActions.js';
import { ChartingFlowParam } from './model.js';
import { chartingFlowStepValidators } from './stepValidation.js';
import { chartingFlowTitleGetters } from './titlesActions.js';

// FLOW CONFIG
const getFlowLoading = () => {
    var _a;
    const store = getStore();
    const route = getRoute();
    const { orderID } = route.value.params;
    if (!orderID)
        return false;
    return !((_a = store.state.chartingFlow.data[orderID]) === null || _a === void 0 ? void 0 : _a.flowLoadingCompleted);
};
/** All data fetched/initialized. */
const getFlowDataIsReady = () => {
    var _a;
    const store = getStore();
    const route = getRoute();
    const { orderID } = route.value.params;
    if (!orderID)
        return false;
    return !!((_a = store.state.chartingFlow.data[orderID]) === null || _a === void 0 ? void 0 : _a.flowDataIsReady);
};
const setNextLoading = (isLoading) => {
    const store = getStore();
    const route = getRoute();
    const { orderID } = route.value.params;
    if (!orderID)
        return;
    store.commit('chartingFlow/SET_NEXT_BUTTON_LOADING', {
        orderID,
        isLoading,
    });
};
const flowConfig = {
    completionActions: chartingFlowCompletionActions,
    getFlowDataIsReady,
    getFlowLoading,
    rootParam: ChartingFlowParam.ORDER_ID,
    setNextLoading,
    stepValidators: chartingFlowStepValidators,
    titleActions: chartingFlowTitleGetters,
};
// STEP BUILDING HELPERS
const buildChartingFlowStep = (routeName, associatedID, associatedParam = ChartingFlowParam.ORDER_ID, subSteps, parentID, parentRouteName, parentAssociatedParam, additionalParams) => addAssociatedIDs({
    associatedParam,
    routeName,
    subSteps,
}, associatedID, parentID, parentRouteName, parentAssociatedParam, additionalParams);
// STEPS
const getRequisitionFormsStep = (orderID) => buildChartingFlowStep(ChartingFlowRouteName.PRINT_REQUISITION_FORMS, orderID, ChartingFlowParam.ORDER_ID, undefined);
const getSpecimenBagsStep = (orderID) => buildChartingFlowStep(ChartingFlowRouteName.SPECIMEN_BAGS, orderID, ChartingFlowParam.ORDER_ID);
// ROOT STEP MAP
const getChartingStepMap = (orderID) => {
    var _a;
    // The step building logic may throw errors in case of missing data. Return
    // empty steps when data is not ready.
    if (!((_a = flowConfig.getFlowDataIsReady) === null || _a === void 0 ? void 0 : _a.call(flowConfig))) {
        return new Map();
    }
    if (!orderID)
        throw toastError('Missing draft order ID when generating steps.');
    const store = getStore();
    const stepMap = new Map();
    if (!store.getters['chartingFlow/isDraftOrder'](orderID)) {
        stepMap.set(ChartingFlowRouteName.PRINT_REQUISITION_FORMS, getRequisitionFormsStep(orderID));
    }
    stepMap.set(ChartingFlowRouteName.SPECIMEN_BAGS, getSpecimenBagsStep(orderID));
    return stepMap;
};
const getChartingFlowHelpers = (route) => {
    const stepMap = getChartingStepMap(route.params.orderID);
    return initFlowHelpers(flowConfig, stepMap);
};

export { getChartingFlowHelpers, getRequisitionFormsStep, getSpecimenBagsStep };
